import Page from './Pagination'

const Pagination = {
  install: function (Vue) {
    Vue.component('Pagination', Page)
  }
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js